var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#1C936B",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node1",
    d: "M1395 2970 c-27 -5 -89 -13 -136 -18 -125 -15 -289 -68 -424 -137 -308 -158 -552 -417 -686 -730 -17 -38 -34 -79 -39 -90 -28 -61 -58 -213 -81 -400 -8 -73 -8 -120 -1 -175 6 -41 14 -106 17 -145 6 -74 20 -132 62 -255 137 -405 489 -764 883 -902 142 -49 185 -60 310 -75 156 -20 235 -21 375 -5 105 12 288 54 310 71 5 5 23 11 40 15 49 12 199 91 306 161 159 104 347 304 437 464 56 101 93 177 104 215 6 23 15 46 19 52 13 17 41 123 54 209 33 203 37 263 25 373 -21 189 -58 363 -81 387 -5 5 -9 18 -9 30 0 32 -116 252 -183 345 -87 121 -242 272 -367 355 -221 148 -420 221 -680 249 -157 17 -179 18 -255 6z m790 -908 c47 -37 59 -62 59 -118 -1 -42 -8 -62 -39 -108 -45 -68 -101 -111 -520 -397 -103 -71 -127 -83 -170 -87 -67 -5 -80 1 -216 98 -43 30 -106 74 -141 98 -275 187 -328 231 -376 306 -48 76 -29 173 43 217 29 18 60 19 680 17 l651 -3 29 -23z m-1259 -495 c172 -115 343 -235 369 -257 11 -10 47 -31 80 -46 105 -50 215 -36 320 41 69 50 388 271 434 300 9 5 37 27 63 47 26 21 49 38 53 38 3 0 5 -155 3 -344 -3 -328 -4 -346 -23 -372 -11 -15 -36 -35 -55 -45 -33 -18 -70 -19 -667 -19 -414 0 -642 4 -662 11 -16 6 -42 27 -58 47 l-28 37 -3 349 -3 349 39 -35 c21 -19 83 -65 138 -101z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node3",
    d: "M825 2071 c-72 -44 -91 -141 -43 -217 48 -75 101 -119 376 -306 35 -24 98 -68 141 -98 136 -97 149 -103 216 -98 43 4 67 16 170 87 419 286 475 329 520 397 31 46 38 66 39 108 0 56 -12 81 -59 118 l-29 23 -651 3 c-620 2 -651 1 -680 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node4",
    d: "M752 1354 l3 -349 28 -37 c16 -20 42 -41 58 -47 20 -7 248 -11 662 -11 597 0 634 1 667 19 19 10 44 30 55 45 19 26 20 44 23 372 2 189 0 344 -3 344 -4 0 -27 -17 -53 -38 -26 -20 -54 -42 -63 -47 -46 -29 -365 -250 -434 -300 -105 -77 -215 -91 -320 -41 -33 15 -69 36 -80 46 -26 22 -197 142 -369 257 -55 36 -117 82 -138 101 l-39 35 3 -349z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5bed137051aec4a5b11ede5e7684a8f7.svg";
export { ForwardRef as ReactComponent };